import ApiService from '../api.service';

const OrderResource = {
  index: (params) => ApiService.query(`/v1/business/${params.business_id}/orders`, params),
  availableUfs: (params) => ApiService.get(`/v1/business/${params.business_id}/orders/available_ufs`),
  create: (params) => ApiService.post(`/v1/business/${params.business_id}/orders`, params),
  show: (params) => ApiService.get(`/v1/business/${params.business_id}/orders/${params.id}`),
};

export default OrderResource;
